import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { EmployeesComponent } from './pages/employees/employees.component';
import { AuthGuard } from '.././_helpers';
import { CnssComponent } from './pages/cnss/cnss.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { FaqComponent } from './pages/faq/faq.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { DependenceComponent } from './pages/dependence/dependence.component';
import { ExperienceComponent } from './pages/experience/experience.component';
import { CnssReportsComponent } from './pages/cnss-reports/cnss-reports.component';
import { SalaryReviseComponent } from './pages/salary-revise/salary-revise.component';
import { MainLayoutComponent } from './pages/layout/main-layout/main-layout.component';
import { GetStartedComponent } from './pages/get-started/get-started.component';
import { LinkBusinessComponent } from './pages/link-business/link-business.component';
import { CnssReportsListComponent } from './pages/cnss-reports-list/cnss-reports-list.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { CnssReportViewComponent } from './pages/cnss-report-view/cnss-report-view.component';
import { CnssApprovalFormComponent } from './pages/cnss-approval-form/cnss-approval-form.component';
import { AddBankComponent } from './pages/add-bank/add-bank.component';
import { ContactFloatingComponent } from './pages/layout/contact-floating/contact-floating.component';
import { OnboardingPortalComponent } from './pages/layout/onboarding-portal/onboarding-portal.component';
import { DependenceListComponent } from './pages/dependence-list/dependence-list.component';
import { CnamgsFormComponent } from './pages/cnamgs-form/cnamgs-form.component';
import { CnamgsReportComponent } from './pages/cnamgs-report/cnamgs-report.component';
import { CnamgsReportlistComponent } from './pages/cnamgs-reportlist/cnamgs-reportlist.component';
import { CnamgsReportviewComponent } from './pages/cnamgs-reportview/cnamgs-reportview.component';
import { BusinessListComponent } from './pages/business-list/business-list.component';
import { EmployeeCnamgsComponent } from './pages/employee-cnamgs/employee-cnamgs.component';
import { EmployeeHistoryComponent } from './pages/employee-history/employee-history.component';
import { N404Component } from './pages/n404/n404.component';
import { VerificationComponent } from './pages/verification/verification.component';
import { FamilyAllowanceComponent } from './pages/family-allowance/family-allowance.component';
import { FamilyAllowanceListComponent } from './pages/family-allowance-list/family-allowance-list.component';
import { FamilyAllowanceViewComponent } from './pages/family-allowance-view/family-allowance-view.component';
import { InvoiceVerificationComponent } from './pages/invoice-verification/invoice-verification.component';
import { VerifyEmployerComponent } from './pages/verify/verify-employer/verify-employer.component';
import { EmployeeTerminationComponent } from './pages/employee-termination/employee-termination.component';

const routes: Routes = [
  {
    path: '', component: HomePageComponent, pathMatch: 'full', data: { state: 'home'}
  },
  {
    path: 'verify-employer/:slug', component: VerifyEmployerComponent, data: { state: 'verify-employer'}
  },
  {
    path: 'verify-employer', component: VerifyEmployerComponent, pathMatch: 'full', data: { state: 'verify-employer'}
  },
  {
        path: 'contact-us', component: ContactUsComponent, pathMatch: 'full', data: { state: 'contact-us'}
  },
  { 
    path: '',
    canActivate: [AuthGuard],
    component: MainLayoutComponent, 
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'dashboard', component: DashboardComponent, pathMatch: 'full', data: { state: 'dashboard'}
      },
      {
        path: 'employees', component: EmployeesComponent, pathMatch: 'full', data: { state: 'employees'}
      },
       {
        path: 'employee-history', component: EmployeeHistoryComponent, pathMatch: 'full', data: { state: 'employee-history'}
      },
       {
        path: 'employee-history/:id', component: EmployeeHistoryComponent, pathMatch: 'full', data: { state: 'employee-history'}
      },
      {
        path: 'cnss', component: CnssComponent, pathMatch: 'full', data: { state: 'cnss'}
      },
      {
        path: 'employee-cnamgs', component: EmployeeCnamgsComponent, pathMatch: 'full', data: { state: 'employee-cnamgs'}
      },
    
      {
        path: 'notfication', component: NotificationComponent, pathMatch: 'full', data: { state: 'notfication'}
      },
      {
        path: 'profile', component: ProfileComponent, pathMatch: 'full',  data: {animation: 'Article', state: 'profile'}
      },
      {
        path: 'dependence', component: DependenceComponent, pathMatch: 'full', data: { state: 'dependence'}
      },
      {
        path: 'dependence/:id', component: DependenceComponent, pathMatch: 'full', data: { state: 'dependence'}
      },
      {
        path: 'experience', component: ExperienceComponent, pathMatch: 'full', data: { state: 'experience'}
      },
      {
        path: 'faq', component: FaqComponent, pathMatch: 'full', data: { state: 'faq'}
      },
      {
        path: 'salary-revise', component: SalaryReviseComponent, pathMatch: 'full', data: { state: 'salary-revise'}
      },
      {
        path: 'salary-revise/:id', component: SalaryReviseComponent, pathMatch: 'full', data: { state: 'salary-revise'}
      },
      {
        path: 'get-started', component: GetStartedComponent, pathMatch: 'full', data: {animation: 'Home', state: 'get-started'}
      },
      {
        path: 'link-business', component: LinkBusinessComponent, pathMatch: 'full', data: { state: 'link-business'}
      },
      {
        path: 'cnss-reportList', component: CnssReportsListComponent, pathMatch: 'full', data: { state: 'cnss-reportList'}
      },
      {
        path: 'cnss-reports/:id/:cnamgsId', component: CnssReportsComponent, pathMatch: 'full', data: { state: 'cnss-reports'}
      },
      {
        path: 'cnss-reports/:id', component: CnssReportsComponent, pathMatch: 'full', data: { state: 'cnss-reports'}
      },
      {
        path: 'cnss-reports', component: CnssReportsComponent, pathMatch: 'full', data: { state: 'cnss-reports'}
      },
      {
        path: 'payment/:id', component: PaymentComponent, pathMatch: 'full', data: { state: 'payment'}
      },
      {
        path: 'cnss-report-view/:id/:cnamgsId', component: CnssReportViewComponent, pathMatch: 'full', data: { state: 'cnss-report-view'}
      },
      {
        path: 'cnss-report-view/:id', component: CnssReportViewComponent, pathMatch: 'full', data: { state: 'cnss-report-view'}
      },
      {
        path: 'cnss-approval-form', component: CnssApprovalFormComponent, pathMatch: 'full', data: { state: 'cnss-approval-form'}
      },
      {
        path: 'add-bank', component: AddBankComponent, pathMatch: 'full', data: { state: 'add-bank'}
      },
      {
        path: 'contact-floating', component: ContactFloatingComponent, pathMatch: 'full', data: { state: 'contact-floating'}
      },
      {
        path: 'onboarding-portal', component: OnboardingPortalComponent, pathMatch: 'full', data: { state: 'onboarding-portal'}
      },
      {
        path: 'dependence-list', component: DependenceListComponent, pathMatch: 'full', data: { state: 'dependence-list'}
      },
       {
        path: 'dependence-list/:id', component: DependenceListComponent, pathMatch: 'full', data: { state: 'dependence-list'}
      },
      {
        path: 'cnamgs-form', component: CnamgsFormComponent, pathMatch: 'full', data: { state: 'cnamgs-form'}
      },
      {
        path: 'cnamgs-report', component: CnamgsReportComponent, pathMatch: 'full', data: { state: 'cnamgs-report'}
      },
      {
        path: 'cnamgs-report/:id', component: CnamgsReportComponent, pathMatch: 'full', data: { state: 'cnamgs-report'}
      },
      {
        path: 'cnamgs-reportlist', component: CnamgsReportlistComponent, pathMatch: 'full', data: { state: 'cnamgs-reportlist'}
      },
      {
        path: 'cnamgs-reportview/:id', component: CnamgsReportviewComponent, pathMatch: 'full', data: { state: 'cnamgs-reportview'}
      },
      {
        path: 'business-list', component: BusinessListComponent, pathMatch: 'full', data: { state: 'business-list'}
      },
      {
        path: 'family-allowance', component: FamilyAllowanceComponent, pathMatch: 'full', data: { state: 'family-allowance'}
      },
      {
        path: 'family-allowance/:id', component: FamilyAllowanceComponent, pathMatch: 'full', data: { state: 'family-allowance'}
      },
      {
        path: 'family-allowance-list', component: FamilyAllowanceListComponent, pathMatch: 'full', data: { state: 'family-allowance-list'}
      },
      {
        path: 'family-allowance-list/:id', component: FamilyAllowanceListComponent, pathMatch: 'full', data: { state: 'family-allowance-list'}
      },
      {
        path: 'family-allowance-view/:id', component: FamilyAllowanceViewComponent, pathMatch: 'full', data: { state: 'family-allowance'}
      },
      {
        path: 'employee-termination', component: EmployeeTerminationComponent, pathMatch: 'full', data: { state: 'employee-termination'}
      }
       
      ]
    },

      {
      path: 'verification/:id', component: VerificationComponent, pathMatch: 'full', data: { state: 'verification'}
    },
    {
      path: 'invoice-verification/:id', component: InvoiceVerificationComponent, pathMatch: 'full', data: { state: 'invoice-verification'}
    },
    { path: '**', component: N404Component, pathMatch: 'full' , data: { state: 'n404'} },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
